var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full p-10 flex justify-between items-center"},[_c('div',{staticClass:"hidden md-block w-150 flex-shrink-0"}),_c('p',{staticClass:"text-13 text-left md-text-center",staticStyle:{"max-width":"45em"}},[_vm._t("text")],2),_c('div',{staticClass:"flex-shrink-0 w-110 md-w-150 text-13 leading-none"},[_vm._t("button")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }